import {
  AppstoreOutlined,
  EditOutlined,
  EyeOutlined,
  LeftOutlined,
  MailOutlined,
  RightOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import {
  Button,
  Drawer,
  MenuProps,
  message,
  Modal,
  Pagination,
  PaginationProps,
  Row,
  Space,
} from "antd";
import { saveAs } from "file-saver";
import _ from "lodash";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import { CommonButton } from "../../components/CommonButton/button";
import { Text } from "../../components/CommonFont/text";
import { SearchBox } from "../../components/CommonSearchBox";
import { CommonTable } from "../../components/commonTable";
import { TableCard } from "../../components/CommonTableCard";
import { AddNewClient } from "../../components/Drawer/AddNewClient";
import { ClientPreview } from "../../components/Drawer/Client-preview";
import { FilterMenu } from "../../components/CommonFilter";
import { getContactsParams } from "../../helpers/quarery";
import {
  useGetAllContactsQuery,
  useGetContactsByIdQuery,
  useGetDownloadDataQuery,
  useGetIndustryQuery,
  useGetRegionQuery,
  useGetTypesQuery,
  useExportSalesReportMutation,
  useEditContactsMutation,
  useGetSpecialNoteQuery,
  useEditSpecialNoteMutation,
} from "../../services/api";

import "./index.css";
import {
  ContactColumn,
  ContactColumnLabels,
  getDefaultContactSelectedColumns,
} from "./contactColumns";
import ExportModal from "../../components/Modals/ReportsModal/ExportModal";
import DateRangeFilter from "../../components/Modals/ReportsModal/DateRangeFilter";
import MultiSelectFilter from "../../components/Modals/ReportsModal/MultiSelectFilter";

export const Contacts = () => {
  const [open, setOpen] = useState(false);
  const [preview, setIsPreview] = useState(false);
  const [edit, setIsEdit] = useState(false);
  const [filter, setFilter] = useState(false);
  const [filterData, setFilterData] = useState<any>();
  const [downloadIds, setDownloadIds] = useState<any>();
  const [selectedRegion, setSelectedRegion] = useState<string[]>([]);
  const [selectedType, setSelectedType] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState([]);

  const { data: industryData } = useGetIndustryQuery({});
  const { data: regionData } = useGetRegionQuery({});
  const { data: typeData } = useGetTypesQuery({});

  // ---------------modal---------------
  const [module, setModule] = useState("contact");
  const [dateRange, setDateRange] = useState<any>(null);

  // Contact filter states
  const [regionIds, setRegionIds] = useState<number[]>([]);
  const [typeIds, setTypeIds] = useState<number[]>([]);
  const [industryIds, setIndustryIds] = useState<number[]>([]);

  // Column selection state using enum
  const [selectedColumns, setSelectedColumns] = useState<Record<string, boolean>>(
    getDefaultContactSelectedColumns(),
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Special Note States
  const [noteViewVisible, setNoteViewVisible] = useState(false);
  const [noteEditVisible, setNoteEditVisible] = useState(false);
  const [currentNote, setCurrentNote] = useState("");
  const [originalNote, setOriginalNote] = useState("");
  const [editingContact, setEditingContact] = useState<{ id: number; [key: string]: any } | null>(null);
  const [pendingModal, setPendingModal] = useState<'view' | 'edit' | null>(null);
  const quillRef = useRef<Quill | null>(null);

  // Edit mutation
  const [editContact, { isLoading: isUpdating }] = useEditContactsMutation();

  // Special Note API hooks
  const [editSpecialNote, { isLoading: isSavingNote }] = useEditSpecialNoteMutation();
  const {
    data: specialNoteData,
    isFetching: specialNoteLoading,
  } = useGetSpecialNoteQuery(
    editingContact?.id || 0,
    {
      skip: !editingContact?.id,
    }
  );

  // Export mutation
  const [exportContact, { isLoading: isExporting }] =
    useExportSalesReportMutation();

  const moduleOptions = [{ label: "Sales Report", value: "sales_report" }];

  const showModal = () => {
    setIsModalOpen(true);
  };

  const resetModalFilters = () => {
    setDateRange(null);
    setRegionIds([]);
    setTypeIds([]);
    setIndustryIds([]);
    setSelectedColumns(getDefaultContactSelectedColumns());
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModalFilters();
  };
  // ---------------modal---------------

  const [pageData, setPageData] = useState<{
    page: number;
    pageSize: number;
  }>({
    page: 0,
    pageSize: 5,
  });
  const params = getContactsParams(pageData.page, pageData.pageSize);

  const [searchParams, setSearchParams] = useSearchParams();

  const search = searchParams.get("search");
  const contact_id = searchParams.get("id");

  const onPaginationChange = (page: number, pageSize: number) => {
    setPageData({ page, pageSize });
  };
  const [id, setIsId] = useState("");
  const [indexId, setIndexId] = useState();

  const userId = localStorage.getItem("user_id");
  const getAllContactsParams = {
    id: userId,
    params: params,
    search: search ? search : "",
    body: JSON.stringify(filterData)
      ? JSON.stringify(filterData)
      : JSON.stringify({}),
  };

  const { data, isLoading, isFetching } =
    useGetAllContactsQuery(getAllContactsParams);
  const { data: contactById, isLoading: contactLoading } =
    useGetContactsByIdQuery(contact_id);

  const findIndexForObject = (array: [], object: any) => {
    return _.findIndex(array, object);
  };

  const targetObject = { id: Number(contact_id) };
  const index = findIndexForObject(data?.results, targetObject);

  const [currentIndex, setCurrentIndex] = useState(index);

  const getObjectAtIndex = (array: [], index: number) => {
    const object = _.get(array, index);
    return object;
  };

  useEffect(() => {
    setCurrentIndex(index);
  }, [index]);

  useEffect(() => {
    if (currentIndex > -1) {
      const updatedObject: any = getObjectAtIndex(data?.results, currentIndex);
      navigate(`/contacts?id=${updatedObject?.id}`);
    }
  }, [currentIndex]);

  const initializeQuill = (el: HTMLDivElement | null) => {
    if (el && !quillRef.current) {
      el.innerHTML = "";
      const quill = new Quill(el, {
        theme: "snow",
        modules: {
          toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image"],
            ["clean"],
          ],
        },
      });
      quillRef.current = quill;
      quill.root.innerHTML = currentNote || "";
      quill.on("text-change", () => {
        setCurrentNote(quill.root.innerHTML);
      });
    }
  };

  useEffect(() => {
    if (!noteEditVisible) {
      quillRef.current = null;
    }
  }, [noteEditVisible]);

  useEffect(() => {
    if (specialNoteData?.data?.special_note) {
      const noteHtml = specialNoteData.data.special_note.html || "";
      setCurrentNote(noteHtml);
      setOriginalNote(noteHtml);
    } else {
      setCurrentNote("");
      setOriginalNote("");
    }
  }, [specialNoteData]);

  // Open modal after data is fetched
  useEffect(() => {
    if (pendingModal && specialNoteData && !specialNoteLoading) {
      if (pendingModal === 'view') {
        setNoteViewVisible(true);
      } else if (pendingModal === 'edit') {
        setNoteEditVisible(true);
      }
      setPendingModal(null);
    }
  }, [pendingModal, specialNoteData, specialNoteLoading]);

  const handleCancelEdit = () => {
    setCurrentNote(originalNote);
    setNoteEditVisible(false);
  };

  const handleSaveNote = async () => {
    if (!editingContact) return;

    try {
      // Get delta from Quill editor
      const delta = quillRef.current?.getContents();
      const html = currentNote;
      const plainText = quillRef.current?.getText() || "";

      const specialNotePayload = JSON.stringify({
        delta: delta,
        html: html,
        plain: plainText.trim()
      });

      // Use special note API
      const response = await editSpecialNote({
        contact_id: editingContact.id,
        body: {
          special_note: specialNotePayload
        }
      }).unwrap();
      
      message.success(response?.message || "Special note updated successfully");
      setOriginalNote(html);
      setNoteEditVisible(false);
    } catch (error: any) {
      message.error(error?.data?.message || "Failed to update special note");
    }
  };

  const handleNext = () => {
    if (currentIndex < data?.results?.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const onClose = () => {
    setOpen(false);
    setIsPreview(false);
    navigate("/contacts");
    setIsEdit(false);
  };

  const navigate = useNavigate();

  const titleData = [
    ContactColumnLabels[ContactColumn.COMPANY_NAME],
    ContactColumnLabels[ContactColumn.REGION_NAME],
    ContactColumnLabels[ContactColumn.PHONE],
    ContactColumnLabels[ContactColumn.EMAIL],
    ContactColumnLabels[ContactColumn.TYPE_NAME],
    ContactColumnLabels[ContactColumn.INDUSTRY_NAME],
    "Special Note",
  ];

  // Define columns using enum
  const columns = [
    {
      title: ContactColumnLabels[ContactColumn.COMPANY_NAME],
      dataIndex: "company_name", // API returns 'company_name'
      sorter: (a: any, b: any) =>
        (a.company_name || "").localeCompare(b.company_name || ""),
      ellipsis: true,
    },
    {
      title:
        ContactColumnLabels[
          ContactColumn.CONTACTS_CUSTOMER_UNIQUE_IDENTIFICATION_NUMBER
        ],
      dataIndex: "contacts_customer_unique_identification_number", // API returns this
      ellipsis: true,
    },
    {
      title: ContactColumnLabels[ContactColumn.REGION_NAME],
      dataIndex: "region_name", // API returns 'region_name' (without underscores)
      sorter: (a: any, b: any) =>
        (a.region_name || "").localeCompare(b.region_name || ""),
      ellipsis: true,
    },
    {
      title: ContactColumnLabels[ContactColumn.PHONE],
      dataIndex: "phone", // API returns 'phone'
      ellipsis: true,
    },
    {
      title: ContactColumnLabels[ContactColumn.EMAIL],
      dataIndex: "email", // API returns 'email'
      render: (text: any) => <div>{text ? text : "-"}</div>,
      ellipsis: true,
    },
    {
      title: ContactColumnLabels[ContactColumn.TYPE_NAME],
      dataIndex: "type_name", // API returns 'type_name' (without underscores)
      ellipsis: true,
    },
    {
      title: ContactColumnLabels[ContactColumn.INDUSTRY_NAME],
      dataIndex: "industry_name", // API returns 'industry_name' (without underscores)
      ellipsis: true,
    },
    {
      title: "Special Note",
      dataIndex: "note",
      render: (text: any, record: any) => (
        <Space size="middle">
          <EyeOutlined
            onClick={(e) => {
              e.stopPropagation();
              setEditingContact(record);
              setPendingModal('view');
            }}
            className="special-note-eye-icon"
          />
          <EditOutlined
            onClick={(e) => {
              e.stopPropagation();
              setEditingContact(record);
              setPendingModal('edit');
            }}
            className="special-note-edit-icon"
          />
        </Space>
      ),
    },
  ];

  // Export columns (for sending to backend)

  const exportColumns = [
    {
      title: ContactColumnLabels[ContactColumn.COMPANY_NAME],
      dataIndex: ContactColumn.COMPANY_NAME,
    },
    {
      title:
        ContactColumnLabels[
          ContactColumn.CONTACTS_CUSTOMER_UNIQUE_IDENTIFICATION_NUMBER
        ],
      dataIndex: ContactColumn.CONTACTS_CUSTOMER_UNIQUE_IDENTIFICATION_NUMBER,
    },
    {
      title: ContactColumnLabels[ContactColumn.REGION_NAME],
      dataIndex: ContactColumn.REGION_NAME,
    },
    {
      title: ContactColumnLabels[ContactColumn.PHONE],
      dataIndex: ContactColumn.PHONE,
    },
    {
      title: ContactColumnLabels[ContactColumn.EMAIL],
      dataIndex: ContactColumn.EMAIL,
    },
    {
      title: ContactColumnLabels[ContactColumn.TYPE_NAME],
      dataIndex: ContactColumn.TYPE_NAME,
    },
    {
      title: ContactColumnLabels[ContactColumn.INDUSTRY_NAME],
      dataIndex: ContactColumn.INDUSTRY_NAME,
    },
  ];

  const columnOptions = exportColumns.map((col) => ({
    dataIndex: col.dataIndex,
    title: col.title,
  }));

  const handleExportDownload = async () => {
    // Get selected columns array
    const selectedColumnsArray = (
      Object.keys(selectedColumns) as Array<keyof typeof selectedColumns>
    ).filter((key) => selectedColumns[key]);

    if (selectedColumnsArray.length === 0) {
      message.error("Please select at least one column to export");
      return;
    }

    try {
      // Build export payload for contact
      const exportPayload: any = {
        module: "contact",
        columns: selectedColumnsArray,
      };

      // Add region filter if selected
      if (regionIds && regionIds.length > 0) {
        exportPayload.region_id = regionIds;
      }

      // Add type filter if selected
      if (typeIds && typeIds.length > 0) {
        exportPayload.type_id = typeIds;
      }

      // Add industry filter if selected
      if (industryIds && industryIds.length > 0) {
        exportPayload.industry_id = industryIds;
      }

      // Add date range if selected
      if (dateRange && dateRange[0] && dateRange[1]) {
        exportPayload.start_date = dateRange[0].format("YYYY-MM-DD");
        exportPayload.end_date = dateRange[1].format("YYYY-MM-DD");
      }

      // Make the API call
      const response = await exportContact(exportPayload).unwrap();

      if (response.status === "success" && response.file_url) {
        message.success(response.message || "Export completed successfully");

        // Fetch and download the file
        const fileResponse = await fetch(response.file_url);
        const blob = await fileResponse.blob();
        saveAs(blob, response.file_name);

        // Close modal and reset filters
        setIsModalOpen(false);
        resetModalFilters();
      } else {
        message.error(response.message || "Export failed. Please try again.");
      }
    } catch (error: any) {
      console.error("Export error:", error);
      if (error?.data) {
        message.error(
          error.data.message ||
            error.data.errorDetails ||
            "Export failed. Please try again.",
        );
      } else {
        message.error("Something went wrong. Please try again.");
      }
    }
  };

  const idArray = _.map(data?.results, "id");

  const handleDownload = () => {
    if (downloadedData) {
      saveAs(downloadedData, "contact-export.xlsx");
    } else {
      message.error("Error: Downloaded data is undefined.");
    }
  };

  const { data: downloadedData, isFetching: downloadLoading } =
    useGetDownloadDataQuery(downloadIds?.length > 0 ? downloadIds : idArray);

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    pageSize,
  ) => {
    setPageData({
      page: current,
      pageSize: pageSize,
    });
  };

  return (
    <>
      <div className="mt-24 ">
        <div className="flex justify-between items-center">
          <div className="sales-title">
            <Text value="Contacts" variant="wearlay-display" />
          </div>
          <CommonButton
            variant="wealay-primary-btn"
            value="    + Add New Client"
            className="primary-btn"
            onClick={() => {
              setOpen(true);
            }}
          />
        </div>
        <div className="p-10 mt-24p">
          <div className="flex justify-between">
            <Text
              value="Customers List"
              variant="wearlay-headline-2"
              className="p-1 "
            />

            <div className="flex items-center h-full gap-2">
              <div className="search-resp ">
                <SearchBox placeholder="Search" />
              </div>
              <div className="relative">
                <CommonButton
                  variant="wearlay-with-icon"
                  icon={filter ? "/assets/close.svg" : "/assets/filter.svg"}
                  onClick={() => {
                    setFilter(!filter);
                  }}
                  className="download-btn-color"
                />

                {filter && (
                  <FilterMenu
                    setFilter={setFilter}
                    setFilterData={setFilterData}
                    filer={filter}
                    filterData={filterData}
                    selectedRegion={selectedRegion}
                    setSelectedRegion={setSelectedRegion}
                    setSelectedIndustry={setSelectedIndustry}
                    selectedIndustry={selectedIndustry}
                    setSelectedType={setSelectedType}
                    selectedType={selectedType}
                  />
                )}
              </div>
              <CommonButton
                variant="wearlay-with-icon"
                icon={
                  data?.results?.length === 0
                    ? "/assets/disabledDownload.svg"
                    : "/assets/download.svg"
                }
                onClick={showModal}
                isLoading={downloadLoading}
                className="download-btn-color"
                disabled={data?.results?.length === 0 || downloadLoading}
              />
            </div>
          </div>
          <div className="resp-search">
            <SearchBox placeholder="Search" />
          </div>
          <div className="resp-table">
            <CommonTable
              datasource={data?.results}
              coloumn={columns}
              setDetailsOpen={setIsPreview}
              isLoading={isLoading || isFetching}
              setId={setIsId}
              setDownloadIds={setDownloadIds}
            />
            {data?.count > 0 && (
              <Row justify={"end"}>
                <Pagination
                  onChange={onPaginationChange}
                  total={data?.count}
                  pageSize={pageData?.pageSize}
                  defaultCurrent={1}
                  responsive={true}
                  onShowSizeChange={onShowSizeChange}
                  showSizeChanger={data?.count > 10 ? true : false}
                />
              </Row>
            )}
          </div>
        </div>
        <TableCard
          headingData={titleData}
          setOpen={setIsPreview}
          data={data?.results}
          setId={setIsId}
          loading={isLoading || isFetching}
        />
        {data?.count > 0 && (
          <Pagination
            onChange={onPaginationChange}
            total={data?.count}
            pageSize={pageData?.pageSize}
            className="pagination-resp"
            defaultCurrent={1}
            onShowSizeChange={onShowSizeChange}
            showSizeChanger={data?.count > 10 ? true : false}
          />
        )}
      </div>

      <Drawer
        title={edit ? "Edit Client" : "Add New Client"}
        placement="right"
        onClose={onClose}
        open={open || edit}
        width="500"
        destroyOnClose={true}
      >
        <AddNewClient
          setOpen={setOpen}
          datas={contactById?.data}
          isEdit={edit}
          setEdit={setIsEdit}
        />
      </Drawer>

      <Drawer
        title={
          <div className="flex justify-between items-center">
            <Text value="Client Preview" variant="wearlay-subtitle" />
            <div>
              <Space>
                <Button onClick={handlePrevious} disabled={currentIndex === 0}>
                  <LeftOutlined />
                </Button>
                <Button
                  onClick={handleNext}
                  disabled={currentIndex === data?.results?.length - 1}
                >
                  <RightOutlined />
                </Button>
              </Space>
            </div>
          </div>
        }
        placement="right"
        onClose={onClose}
        open={preview}
        width="500"
      >
        <ClientPreview
          data={contactById?.data}
          setEdit={setIsEdit}
          setPreview={setIsPreview}
          loading={contactLoading}
        />
      </Drawer>

      <ExportModal
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
        title="Contacts"
        columnOptions={columnOptions}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleDownload={handleExportDownload}
        isExporting={isExporting}
      >
        {/* Children - Filters for Contacts */}
        {/* <DateRangeFilter dateRange={dateRange} setDateRange={setDateRange} /> */}
        <MultiSelectFilter
          value={regionIds}
          onChange={setRegionIds}
          options={regionData || []}
          label="Region"
          placeholder="Select regions"
        />
        <MultiSelectFilter
          value={typeIds}
          onChange={setTypeIds}
          options={typeData || []}
          label="Type"
          placeholder="Select types"
        />
        <MultiSelectFilter
          value={industryIds}
          onChange={setIndustryIds}
          options={industryData || []}
          label="Industry"
          placeholder="Select industries"
        />
      </ExportModal>

      {/* View Special Note Modal */}
      <Modal
        title="View Special Note"
        open={noteViewVisible}
        onCancel={() => setNoteViewVisible(false)}
        footer={[
          <Button key="close" onClick={() => setNoteViewVisible(false)} className="special-note-close-btn">
            Close
          </Button>,
        ]}
        className="special-note-view-modal"
      >
        <div 
          className="special-note-view-container ql-editor" 
          dangerouslySetInnerHTML={{ __html: currentNote || "No note available" }} 
        />
      </Modal>

      {/* Edit Special Note Modal */}
      <Modal
        title="Edit Special Note"
        open={noteEditVisible}
        onCancel={handleCancelEdit}
        onOk={handleSaveNote}
        confirmLoading={isSavingNote}
        destroyOnClose
        className="special-note-edit-modal"
        okButtonProps={{ className: "special-note-ok-btn" }}
        cancelButtonProps={{ className: "special-note-cancel-btn" }}
      >
        <div className="special-note-edit-container">
          <div ref={initializeQuill} className="special-note-editor" />
        </div>
      </Modal>
    </>
  );
};
export default Contacts;
